// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__18vl4","title":"InfoRow_title__1zwGY"};